import { Routes } from '@angular/router';
import { RoleGuard } from '../../common/guards/role.guard';
import { Roles } from '../../common/models/roles';
import { AuthGuard } from '../../common/guards/auth.guard';
import { MunicipalitiesComponent } from './municipalities/municipalities.component';
import { MunicipalityComponent } from './municipality/municipality.component';
import { UsersComponent } from './users/users.component';
import { UserComponent } from './user/user.component';


export const administratorRoutes: Routes = [
    {
      path: 'administrator',
      canActivate: [AuthGuard, RoleGuard],
      data: { roles: [Roles.SystemAdministrator] },
      children: [
        { path: 'users', component: UsersComponent },
        { path: 'users/create', component: UserComponent },
        { path: 'users/:id/edit', component: UserComponent },
        { path: 'municipalities', component: MunicipalitiesComponent },
        { path: 'municipalities/:id/edit', component: MunicipalityComponent }
      ]
    }

]